const SALE_TRACKING_LABEL = 'sale';
const checkTrackingLabel = (menuItem) => {
    return menuItem.trackingLabel === SALE_TRACKING_LABEL;
};
export const isSaleBannerEnabled = (trackingLabel, saleBannerText) => {
    return trackingLabel === SALE_TRACKING_LABEL && !!saleBannerText;
};
export const reOrderSaleNode = (menuItems) => {
    const saleNodeIndex = menuItems.findIndex(checkTrackingLabel);
    if (saleNodeIndex < 0)
        return menuItems;
    const saleNodeData = menuItems[saleNodeIndex];
    if (!(saleNodeData === null || saleNodeData === void 0 ? void 0 : saleNodeData.saleBannerText))
        return menuItems;
    if ((saleNodeData === null || saleNodeData === void 0 ? void 0 : saleNodeData.saleBannerText) !== '') {
        menuItems.splice(saleNodeIndex, 1);
        menuItems.splice(0, 0, saleNodeData);
    }
    return menuItems;
};
//# sourceMappingURL=saleBannerUtility.js.map